import {
  Valuation,
  winterTireTypes,
  winterTireTypeKeys
} from '~/App/shared/interfaces/Valuation';

export const hasExtraWinterTires = (valuation?: Valuation): boolean => {
  const extraTires = valuation?.endUserTestProtocol?.tires?.extraTires?.other;
  const extraTiresTypeKey = extraTires?.tireTypeKey;

  return extraTiresTypeKey
    ? winterTireTypeKeys.includes(extraTiresTypeKey)
    : Boolean(
        extraTires?.tireType && winterTireTypes.includes(extraTires.tireType)
      );
};
